import styled from 'styled-components';

import { ErrorTriangleLImg } from 'assets/images';
import { Button } from 'components/uikit/Button/Button';

export const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 999999999;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 192px;
  gap: 24px;
`;

export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledImg = styled(ErrorTriangleLImg)``;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.h2`
  margin-bottom: 8px;

  font: var(--font-heading-large-20_2);
`;

export const Description = styled.p`
  margin-bottom: 0;
  color: var(--color-grey-11_60);

  font: var(--font-regular-15);
`;

export const StyledButton = styled(Button).attrs({ size: 'm' })`
  width: 179px;
`;
